<template>
  <div class="subcat-label-block">
  <div class="subcat-label" tabindex="0"
    v-on:click="toggleIndicators"
    v-on:keyup.enter="toggleIndicators"
    v-on:keyup.space="toggleIndicators">
      <i :class="collapseIcon" class="fa collapse-icon" aria-hidden="true"></i>{{subcategory.name}}
  </div>
    <transition name="collapse">
      <div v-show="subcategory.showCurrentIndicators" class="indicators-block" 
        :aria-hidden="!subcategory.showCurrentIndicators">
        <legend-indicator v-for="indicator in subcategory.indicators" 
          :key="indicator.name | makeID"
          :indicator="indicator">
            {{indicator.name}}
        </legend-indicator>
      </div> 
    </transition>
  </div>   
</template>

<script>
import LegendIndicator from './LegendIndicator';
import { toggleIndicators } from '../../helpers/openCloseHelpers';

export default {
  name: 'legend-subcat-block',
  props: ['subcategory'],
  components: {
    'legend-indicator': LegendIndicator,
  },
  computed: {
    collapseIcon() {
      return this.subcategory.showCurrentIndicators ? 'fa fa-caret-down' : 'fa fa-caret-right';
    },
  },
  methods: {
    toggleIndicators,
  },
};
</script>

<style lang="less">
  .subcat-label {
    height: 20px;
    padding-left: 5px;
    cursor: pointer;
    margin-bottom: 2px;
    border-bottom: 1px solid #ccc;
    @media (max-width: 800px) {
      white-space: nowrap;
      overflow: visible;
      width: 240px;
    }
    @media print {
      width: 378px;
    }
  }
  .collapse-icon {
    margin-right: 5px;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// LegendSubcatBlock.vue?04535d5e